import { render, staticRenderFns } from "./TabLinkEl.vue?vue&type=template&id=d6be77f6&scoped=true&"
import script from "./TabLinkEl.vue?vue&type=script&lang=ts&"
export * from "./TabLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./TabLinkEl.vue?vue&type=style&index=0&id=d6be77f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be77f6",
  null
  
)

export default component.exports